import actionTypes from '../../actions/action-types';

export default (state = {}, action) => {
  switch (action.type) {
    case actionTypes.FETCH_SFTP_BY_ID_SUCCESS:
      return { ...action.sftp };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/report-subscriptions/reducers/sftp/selected-sftp-entry.js